import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { ROUTES_DEFAULT_ARRAY } from '../constants';

const Navigator = () => {

  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      {ROUTES_DEFAULT_ARRAY.map((route) => (
        <Route key={route.path} {...route} />
      ))}
    </Routes>
  )
};

export default Navigator;
